import { Backdrop, SpeedDial, SpeedDialAction } from "@mui/material";
import { useRouter } from "next/router";
import { useState } from "react";
import { Phone, SupportIcon } from "src/icons/core";
import { Instagram, Telegram, Whatsapp } from "src/icons/socials";

const actions = [
  {
    name: "مرکزتماس",
    icon: <Phone color="success" sx={{ color: "primary", fill: "primary" }} />,
  },
  {
    name: "Whatsapp",
    icon: <Whatsapp sx={{ color: "primary", fill: "primary" }} />,
  },
  {
    name: "Telegram",
    icon: <Telegram sx={{ color: "primary", fill: "primary" }} />,
  },
  {
    name: "تیکت",
    icon: <SupportIcon sx={{ color: "primary", fill: "primary" }} />,
  },
];

export const SupportButton = () => {
  const router = useRouter();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = (action) => {
    if (action === "Whatsapp") {
      window.open(
        "https://api.whatsapp.com/send?phone=+989175113478",
        "_blank"
      );
    } else if (action === "Telegram") {
      window.open("https://t.me/+-hhFXt4qvWIxYjhk", "_blank");
    } else if (action === "مرکزتماس") {
      window.open("tel:02191031644", "_blank");
    } else if (action === "تیکت") {
      router.push("/tickets");
    }
    setOpen(false);
  };
  return (
    <>
      <Backdrop open={open} />
      <SpeedDial
        ariaLabel="SpeedDial tooltip example"
        FabProps={{
          color: "success",
        }}
        sx={{
          position: "fixed",
          bottom: { xs: 75, lg: 40 },
          right: 16,
          zIndex: 1000,
        }}
        icon={<SupportIcon sx={{ width: 35, height: 35 }} />}
        onClose={handleClose}
        onOpen={handleOpen}
        open={open}
      >
        {actions.map((action) => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            tooltipOpen
            onClick={() => handleClose(action.name)}
          />
        ))}
      </SpeedDial>
    </>
  );
};
